import React from "react";
import styled, { css } from "styled-components";
import { useMappedState } from "redux-react-hook";

import Grid from "src/library/components/Hedron";
import { IProduct } from "src/core/products/api/products.api";
import { IDrop } from "src/core/drops/api/drops.api";
import { InstalledModuleType } from "src/utils/constants";
import Price from "src/core/prices/components/Price";
import { usePriceVisibility } from "src/core/prices/hooks/use-price-visibility";
import { IStore } from "src/core/shared/store";

interface ProductPricingProps {
  product: IProduct;
  quantity?: number;
  drop: IDrop | null;
  installedModules: InstalledModuleType[];
}

export const ProductPricing: React.ReactFCWithChildren<ProductPricingProps> = ({
  product,
  quantity,
  drop,
  installedModules
}) => {
  /** set the mode based on order or list mode to control the price format */
  const mode = useMappedState((store: IStore) => {
    if (store.orders.currentOrder.mode === "edit" || store.lists.currentList.mode === "edit") {
      return "edit";
    }

    return "view";
  });

  const pricesVisible = usePriceVisibility();

  return !drop || !pricesVisible ? null : (
    <PricingWrapper className="price-wrapper">
      <Price
        mode={mode}
        product={product}
        quantity={quantity}
        installedModules={installedModules}
        type="unit"
      />

    </PricingWrapper>
  );
};

const PricingWrapper = styled(Grid.Box)`
  ${({ theme }) => css`
    margin-right: ${theme.spacing.margins.md};
    
    .vat-wrapper {
      margin-left: 0;
      display: block;
    }
  `};
`;
